// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UmpdModalContent_root__13ZIq {\n    --color-secondary: var(--theme-brand-primary);\n}\n\n.UmpdModalContent_highlighted_addOn__1S7PL {\n    color: var(--color-secondary);\n}", "",{"version":3,"sources":["webpack://src/auto/components/__regionalComponents/Georgia/UmpdModalContent/UmpdModalContent.module.css"],"names":[],"mappings":"AAAA;IACI,6CAA6C;AACjD;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":[".root {\n    --color-secondary: var(--theme-brand-primary);\n}\n\n.highlighted_addOn {\n    color: var(--color-secondary);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "UmpdModalContent_root__13ZIq",
	"highlighted_addOn": "UmpdModalContent_highlighted_addOn__1S7PL"
};
export default ___CSS_LOADER_EXPORT___;
